"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.artifactType = exports.NodeConfigSchema = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const types_1 = require("../../uiNodes/tapes/raw-supplemental-tape/types");
exports.NodeConfigSchema = types_1.IntermediateRecordConfigSchema;
exports.artifactType = 'rawSupplementalTape';
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    type: zod_1.z.literal(exports.artifactType),
    externalFilename: zod_1.z.string(),
    loanProductSlug: zod_1.z.string().nullable(),
    creditFacilitySlug: zod_1.z.string().nullable(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map